"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsx jsx */
const react_1 = require("@emotion/react");
const prop_types_1 = __importDefault(require("prop-types"));
const b_1 = __importDefault(require("b_"));
const special_options_as_buttons_1 = __importDefault(require("src/components/special-options-as-buttons"));
const question_1 = __importDefault(require("../question"));
const question_scale_1 = __importDefault(require("../question-scale"));
const special_option_1 = __importDefault(require("../question-choice/special-option"));
const question_emotion_styles_1 = __importDefault(require("./question-emotion.styles"));
const question_emotion_feedback_demo_styles_1 = __importDefault(require("./question-emotion-feedback-demo.styles"));
const question_emotion_option_1 = __importDefault(require("./question-emotion-option"));
const b = b_1.default.with('emotion');
const sb = b_1.default.with('special-options-as-buttons');
const DEFAULT_PROPS = {
    noOpinionAnswer: {
        enabled: false
    },
    handleClickNoOpinionAnswer: () => { },
    handleClickOption: () => { },
    options: [],
    id: 0,
    labels: [],
    children: [],
    feedbackDemoMode: false
};
// @ts-expect-error TS(2417): Class static side 'typeof Emotion' incorrectly ext... Remove this comment to see the full error message
class Emotion extends question_scale_1.default {
    renderSpecialOption() {
        const { noOpinionAnswer, handleClickNoOpinionAnswer, multipleChoice, questionIndex } = this.props;
        const specialOptionProps = { multipleChoice, questionIndex };
        return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: sb('button') }, { children: (0, jsx_runtime_1.jsx)(special_option_1.default, Object.assign({ option: noOpinionAnswer, clickHandler: handleClickNoOpinionAnswer, value: -2 }, specialOptionProps)) })));
    }
    render() {
        const _a = this.props, { noOpinionAnswer, otherAnswerWithText, handleClickOption, handleClickNoOpinionAnswer, handleClickOther, handleChangeOtherWithText, handleBlurOtherWithText, handleClickOtherWithText, options, otherAnswer, children, labels, theme, feedbackDemoMode } = _a, rest = __rest(_a, ["noOpinionAnswer", "otherAnswerWithText", "handleClickOption", "handleClickNoOpinionAnswer", "handleClickOther", "handleChangeOtherWithText", "handleBlurOtherWithText", "handleClickOtherWithText", "options", "otherAnswer", "children", "labels", "theme", "feedbackDemoMode"]);
        const styles = [question_emotion_styles_1.default];
        if (feedbackDemoMode)
            styles.push(question_emotion_feedback_demo_styles_1.default);
        return ((0, jsx_runtime_1.jsxs)(question_1.default, Object.assign({}, rest, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ css: styles, className: b({ count: options.length }) }, { children: [(0, jsx_runtime_1.jsx)(question_emotion_option_1.default, { options: options, labels: labels, theme: theme, handleClickOption: handleClickOption }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('special-options') }, { children: (0, jsx_runtime_1.jsx)(special_options_as_buttons_1.default, { theme: this.props.theme, multipleChoice: this.props.multipleChoice, questionIndex: this.props.questionIndex, noOpinionAnswer: noOpinionAnswer, otherAnswer: otherAnswer, otherAnswerWithText: otherAnswerWithText, handleChangeOtherWithText: handleChangeOtherWithText, handleClickNoOpinionAnswer: handleClickNoOpinionAnswer, handleClickOther: handleClickOther, handleClickOtherWithText: handleClickOtherWithText, handleBlurOtherWithText: handleBlurOtherWithText }) }))] })), children] })));
    }
}
exports.default = Emotion;
Emotion.defaultProps = DEFAULT_PROPS;
Emotion.propTypes = {
    noOpinionAnswer: prop_types_1.default.object,
    handleClickNoOpinionAnswer: prop_types_1.default.func.isRequired,
    handleClickOption: prop_types_1.default.func.isRequired,
    options: prop_types_1.default.array,
    labels: prop_types_1.default.array,
    feedbackDemoMode: prop_types_1.default.bool,
    id: prop_types_1.default.number,
    children: prop_types_1.default.oneOfType([
        prop_types_1.default.arrayOf(prop_types_1.default.node),
        prop_types_1.default.node
    ])
};
